import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { CircularLoader } from '../circular-loader';
export const InfiniteScroll = ({ infiniteScrollLoading, initialLoading, onInfiniteScroll, hasNext, children, ref, ...props }) => {
    const anyLoading = initialLoading || infiniteScrollLoading;
    const { ref: endRef, inView: endInView } = useInView();
    useEffect(() => {
        if (!endInView || anyLoading || !hasNext) {
            return;
        }
        onInfiniteScroll?.();
    }, [endInView, anyLoading, hasNext, onInfiniteScroll]);
    return (_jsxs(Root, { ref: ref, ...props, children: [!initialLoading && children, hasNext && (_jsxs(LoaderWrapper, { children: [!anyLoading && _jsx(LoadTrigger, { ref: endRef }), _jsx(CircularLoader, {})] }))] }));
};
const Root = styled.div `
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
`;
const LoaderWrapper = styled.div `
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
`;
const LoadTrigger = styled.div `
  height: 1px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
//# sourceMappingURL=infinite-scroll.js.map